var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.331,
    height: 24.477,
    viewBox: "0 0 33.331 24.477",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked",
    transform: "translate(0 -67.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "translate(0 67.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8461",
    "data-name": "Path 8461",
    d: "M32.842,68.486a1.666,1.666,0,0,0-2.357,0L10.519,88.452,2.845,80.777A1.667,1.667,0,1,0,.488,83.134l8.853,8.853a1.667,1.667,0,0,0,2.357,0L32.842,70.843A1.667,1.667,0,0,0,32.842,68.486Z",
    transform: "translate(0 -67.997)",
    fill: "#dc3a1a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.e19fd254de4c203aa702eaa2e0c93cd0.svg";
export { ForwardRef as ReactComponent };